import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, SERVICE_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
const TITLE = "Recommended product";
const PRODUCT_TO_IMAGE = {
    [WORK_MANAGEMENT_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-wm.png",
    [CRM_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-crm.png",
    [DEV_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-dev.png",
    [SERVICE_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/v1721314019/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-dervice.png"
};
export const getSelectedProductDetails = (selectedProducts = [])=>{
    if (!selectedProducts.length) return null;
    const selectedProduct = selectedProducts[selectedProducts.length - 1] || WORK_MANAGEMENT_PRODUCT_ID;
    return {
        title: TITLE,
        imageSrc: PRODUCT_TO_IMAGE[selectedProduct]
    };
};
